import { minHeight, mq } from '@sleepstation/style-api-helpers'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { useQuery } from 'urql'
import { CustomerNavigationItemsQuery } from '../../../../graphql/documents'
import useDisplayError from '../../../../hooks/useDisplayError'
import LoadOverlay from '../../../shared/LoadOverlay'
import Navbar from './Navbar'
import RoutingContext from '../../../../context/RoutingContext'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div.attrs({ 'data-cy': `old-app-header` })`
  position: relative;
  z-index: 5;
  background-color: #032841;
  ${minHeight([5, 6, 3.2])}

  > * {
    margin-left: auto;
    margin-right: auto;
    ${mq(`mediumOnly`)} {
      max-width: ${rem(1000)};
    }

    ${mq(`largeUp`)} {
      max-width: ${rem(1280)};
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const OldAppHeader = ({ isFixed, hideBackground }) => {
  const { displayError } = useDisplayError()

  const [result] = useQuery({ query: CustomerNavigationItemsQuery })

  const { data, fetching, error } = result

  const {
    appRouting: { homePath },
  } = useContext(RoutingContext)

  if (error) {
    displayError(`Couldn’t load navigation menu`, error)
  }

  return (
    <Layout isFixed={isFixed} hideBackground={hideBackground}>
      {fetching ? (
        <LoadOverlay />
      ) : (
        <Navbar links={data.customerNavigationItems} logoLink={homePath} />
      )}
    </Layout>
  )
}

OldAppHeader.propTypes = {
  isFixed: PropTypes.bool,
  hideBackground: PropTypes.bool,
}

OldAppHeader.defaultProps = { isFixed: false, hideBackground: false }

export default OldAppHeader
